<template>
  <v-card class="pa-4" rounded="lg">
    <p style="font-size: 16px; opacity: 0.8;" class="mb-4">
      Create one or more collections to automatic synchronization filtered GMC catalogs to your product list.
    </p>
    <Resource
      :countt="parseInt(countt)"
      :resourceType="resourceType"
      :document="document"
      :filter-fields="null"
      :filter-data="filterData"
      :filter-callback="setFilterData"
      :searchable="searchableField"
      :columns="columns"
      :routeName="updateRouteName"
      class="mb-4"
    />
    <div class="d-flex justify-space-between">
      <limit-page :callback="setLimit" />
      <pagination
        :length="lengthPage"
        :visible="0"
        v-if="!$parent.isLoading && document"
        :page.sync="page"
      ></pagination>
    </div>
  </v-card>
</template>

<script>
import Resource from '@/components/Resources';
import resourceListMixin from '@/mixins/resource-list';

export default {
  components: { Resource },
  mixins: [resourceListMixin],
  data() {
    return {
      selectAll: '',
      resourceType: 'sync-collections',
      tabs: [{ name: 'Automated collections', key: 'smart' }],
      testVuex: null,
      columns: {
        Collections: {
          field: 'title',
          kind: 'viewCollection',
        },
        Available: {
          field: 'published',
          kind: 'status',
        },
        Conditions: {
          field: 'rules',
          kind: 'rules',
        },
      },
      updateRouteName: 'website.gmc.sync-collections.update',
      searchableField: 'title_search',
      sortable: [],
    };
  },
  created() {},
  methods: {},
};
</script>
